var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronsRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "chevrons-right_svg__feather chevrons-right_svg__feather-chevrons-right"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 17l5-5-5-5M6 17l5-5-5-5"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0iZmVhdGhlciBmZWF0aGVyLWNoZXZyb25zLXJpZ2h0Ij48cG9seWxpbmUgcG9pbnRzPSIxMyAxNyAxOCAxMiAxMyA3Ij48L3BvbHlsaW5lPjxwb2x5bGluZSBwb2ludHM9IjYgMTcgMTEgMTIgNiA3Ij48L3BvbHlsaW5lPjwvc3ZnPgo=";
export { SvgChevronsRight as ReactComponent };